// 7 px presence dot (shared.css .pd): blue live, orange stale, grey off, red
// error. A dot carries ONE meaning. Pass `presence` for route health, or
// `source` for a family swatch in a legend; passing presence wins and the
// family attribute is not emitted, so a family colour can never paint over a
// stale route (redo-2 P1). The platform mark beside a presence dot is
// SourceGlyph, a separate element.
import { cx } from './cx';
import './PresenceDot.css';

export type Presence = 'live' | 'stale' | 'setup' | 'off' | 'error';
export type SourceFamily = 'telegram' | 'discord' | 'x' | 'market' | 'wallet';

export interface PresenceDotProps {
  readonly presence?: Presence | undefined;
  readonly source?: SourceFamily | undefined;
  // Always beside its label in the product, so the dot is decorative unless a
  // label is passed explicitly.
  readonly label?: string | undefined;
  readonly className?: string;
}

export function PresenceDot({ presence, source, label, className }: PresenceDotProps) {
  // A family swatch only when no presence is given; otherwise presence, with
  // "off" as the resting value.
  const asFamily = presence === undefined && source !== undefined;
  return (
    <span
      className={cx('pd', className)}
      data-presence={asFamily ? undefined : (presence ?? 'off')}
      data-src={asFamily ? source : undefined}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
